import { useEffect as e, useState as t } from "/home/runner/work/oko-web/oko-web/node_modules/react/index.js";
//#region src/lib/hooks/useDebounce.ts
function n(n = 350) {
	let [r, i] = t(), [a, o] = t();
	return e(() => {
		let e = setTimeout(() => i(a), n);
		return () => clearTimeout(e);
	}, [a, n]), [r, o];
}
//#endregion
export { n as useDebounce };
